/**
 * oddit-section-collection-carousel
 * Handles scroll progress indicator sync on mobile
 */
(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-carousel';
  var sectionState = new Map();

  function initSection(section) {
    if (sectionState.has(section)) return;

    var track = section.querySelector('.oddit-section-collection-carousel__track');
    var progressBar = section.querySelector('.oddit-section-collection-carousel__progress-bar');

    if (!track || !progressBar) return;

    var cards = track.querySelectorAll('.oddit-section-collection-carousel__card');
    var totalCards = cards.length;
    if (totalCards === 0) return;

    function updateProgress() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        progressBar.style.transform = 'translateX(0)';
        return;
      }

      var scrollRatio = scrollLeft / maxScroll;
      var barWidthPercent = 100 / totalCards;
      var translateX = scrollRatio * (100 - barWidthPercent);

      progressBar.style.width = barWidthPercent + '%';
      progressBar.style.transform = 'translateX(' + (translateX / barWidthPercent * 100) + '%)';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });

    // Initial state
    updateProgress();

    sectionState.set(section, {
      track: track,
      updateProgress: updateProgress
    });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    state.track.removeEventListener('scroll', state.updateProgress);
    sectionState.delete(section);
  }

  // Init all instances on page
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
